import * as React from 'react';
import {styled, mq} from '../../../utils';
import {Header} from '../../Layout';
import {padding} from 'polished';

const Root = styled(Header)({
  padding: 15,
  [mq('laptopAndUp')]: padding(28, 50, 0)
});

const InnerContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  [mq('laptopAndUp')]: {
    justifyContent: 'flex-end'
  }
});

export default ({children}: React.AllHTMLAttributes<'header'>) => (
  <Root>
    <InnerContainer>{children}</InnerContainer>
  </Root>
);



// WEBPACK FOOTER //
// ./src/components/AuthLayout/Header/Header.tsx